import { MenuProps }           from 'antd';
import { Button }              from 'antd';
import { Dropdown }            from 'antd';
import Search                  from 'components/App/IntlSearch';
import currentSession          from 'utils/currentSession';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';

interface TopRightMenuWidgetsProps {
  handleMenuClick?: () => void;
  handleOnSearch?: (value: string) => void;
}

const TopRightMenuWidgets = ({ handleMenuClick, handleOnSearch }: TopRightMenuWidgetsProps) => {
  const menuItems: MenuProps['items'] = [
    {
      key: 'ADD_A_SHOW',
      label: <FormattedMessageWrapper id="Ajouter un salon" />,
    },
  ];

  return (
    <>
      <Search onSearch={handleOnSearch} placeholder="Rechercher un salon" style={{ width: 200 }} />
      {currentSession.isGrantedRoleAdmin && (
        <Dropdown
          menu={{
            items: menuItems,
            onClick: handleMenuClick
          }}
          trigger={['click']}
        >
          <Button htmlType="button" style={{ marginLeft: 8 }}>
            ...
          </Button>
        </Dropdown>
      )}
    </>
  );
};

export default TopRightMenuWidgets;
